import React from 'react';
import { Box, PrintOutlinedIcon, Typography, Button, } from '@kareo/design-system';
import { Grid } from '@material-ui/core';
import CreateNoteButton from 'shared-assets/facesheet-ui/components/Facesheet/Header/CreateNoteButton';
import MoreMenu from 'shared-assets/facesheet-ui/components/Facesheet/Header/MoreMenu';
var openFacesheetPrintPDF = function (patientId) {
    var url = "/patients/print/" + patientId + ".pdf";
    window.open(url, '_blank');
};
var HeaderRightLinks = function (_a) {
    var patientId = _a.patientId;
    return (React.createElement(Box, { marginRight: "1rem" },
        React.createElement(Grid, { container: true, spacing: 2, wrap: "nowrap" },
            React.createElement(Grid, { item: true },
                React.createElement(Button, { variant: "text", startIcon: React.createElement(PrintOutlinedIcon, null), color: "vitality", onClick: function () { return openFacesheetPrintPDF(patientId); } },
                    React.createElement(Typography, { component: "div" }, "Print"))),
            React.createElement(Grid, { item: true },
                React.createElement(MoreMenu, { patientId: patientId })),
            React.createElement(Grid, { item: true, style: { alignSelf: 'center', marginLeft: '.5rem' } },
                React.createElement(CreateNoteButton, { patientId: patientId })))));
};
export default HeaderRightLinks;
